export const MASTER_EMAILS = [
  "master@safetyplanner.de",
  "avst@safetyplanner.de",
];

export function isMaster(email) {
  if (!email) return false;
  return MASTER_EMAILS.includes(String(email).toLowerCase().trim());
}
